const logNames = {
   appWrite: "*APPW*"
}

export { logNames }
